var exports = {
  "HS": "ChannelMembers.module__groupContainer___X1htbG",
  "x_": "ChannelMembers.module__groupHeader___X1htbG",
  "nF": "ChannelMembers.module__virtualGroupRow___X1htbG",
  "xQ": "ChannelMembers.module__groupHeaderLabel___X1htbG",
  "A5": "ChannelMembers.module__groupHeaderRoleIcon___X1htbG",
  "Px": "ChannelMembers.module__groupHeaderSeparator___X1htbG",
  "gV": "ChannelMembers.module__groupHeaderCount___X1htbG",
  "cr": "ChannelMembers.module__membersList___X1htbG",
  "fL": "ChannelMembers.module__virtualListContent___X1htbG",
  "wt": "ChannelMembers.module__virtualRow___X1htbG",
  "ar": "ChannelMembers.module__virtualMemberRow___X1htbG",
  "CU": "ChannelMembers.module__groupSpacer___X1htbG",
};

module.exports = exports;
